<vw-toast-popup [isOpen]="isOpen" width="100%" borderRadius="20px" customClass="bg-white" (close)="onClose()">
  <div class="flex flex-col items-center text-center p-4">
    <p class="mb-4 mt-10 mx-6 text-xl font-semibold text-primary-dark">
      {{ confirmMessage | translate }}
    </p>

    <vw-button (onClick)="confirm.emit()" [look]="'clear'" [label]="confirmYes | translate"
      customClass="text-center m-auto w-full z-[999]" [iconTemplate]="yesIcon" [iconPosition]="'right'">
      <ng-template #yesIcon>
        <vw-check-icon></vw-check-icon>
      </ng-template>
    </vw-button>

    <vw-button (onClick)="cancel.emit()" [look]="'primary'" [label]="confirmNo | translate"
      customClass="text-center mt-4 m-auto w-full z-[999]" [iconTemplate]="noIcon" [iconPosition]="'right'">
      <ng-template #noIcon>
        <div class="size-6">
          <vw-close-icon></vw-close-icon>
        </div>
      </ng-template>
    </vw-button>
  </div>

</vw-toast-popup>